export default __webpack_public_path__ + "static/campaign-6f5ee1f203eb6968614e7c00980afc0e.webm";